import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "./Header/Header";
import NewsPreviewContainer from "./NewsPreview/NewsPreviewContainer";
import NewsFeed from "./NewsPreview/NewsFeed";
import FooterGallery from "./FooterGallery/footerGallery";

const MainPage = () => {
  return (
      <>
        <Helmet>
          <meta
              name="viewport"
              content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
          />
        </Helmet>
        <Header />
        <NewsPreviewContainer />
        <NewsFeed/>
        <FooterGallery/>
      </>
  );
};

export default MainPage;
